import { useTitle } from '@vueuse/core'
import { inject, unref, watchEffect } from 'vue'

import { brandShort } from '@/../app.config'

export const defaultTitle = `${brandShort}: Your one stop shop for lab management.`
export const formatTabTitle = (label) =>
  label ? `${label} — ${brandShort}` : defaultTitle

export function usePageShell({ title, icon, loading, error } = {}) {
  const shell = inject('page-shell')

  if (icon != null) watchEffect(() => shell.setIcon(unref(icon)))
  if (loading != null) watchEffect(() => shell.setLoading(unref(loading)))
  if (error != null) watchEffect(() => shell.setError(unref(error)))

  if (title != null) {
    // shell.setTitle drives the in-page header; useTitle drives the browser tab
    const tabTitle = useTitle()
    watchEffect(() => {
      const label = unref(title)
      shell.setTitle(label)
      tabTitle.value = formatTabTitle(label)
    })
  }

  return shell
}
